import React, { createContext, useState, useEffect } from 'react';
import { lightModeColors, darkModeColors } from '../utils/colors';

const DarkModeContext = createContext();

let darkModeState = false; // Variable to hold dark mode state outside the component

export function DarkModeContextProvider(props) {
  const [darkMode, setDarkMode] = useState(darkModeState);

  function toggleDarkMode() {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    darkModeState = newDarkMode; // Update the dark mode state variable
  }

  useEffect(() => {
    const { textColor, backgroundColor } = darkMode ? darkModeColors : lightModeColors;
    document.body.style.color = textColor;
    document.body.style.backgroundColor = backgroundColor;

  }, [darkMode]);

  const contextValue = {
    darkMode: darkMode,
    toggleDarkMode: toggleDarkMode,
  };

  return (
    <DarkModeContext.Provider value={contextValue}>
      {props.children}
    </DarkModeContext.Provider>
  );
}

export default DarkModeContext;
